var React = require('react');

function OpenInNew (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.78906 6.37005L12.767 1.39209","stroke":"#292D32","strokeWidth":"0.910602","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M13.2577 3.8203V0.906372H10.3438","stroke":"#292D32","strokeWidth":"0.910602","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M6.5808 0.906372H5.36666C2.33132 0.906372 1.11719 2.12051 1.11719 5.15585V8.79826C1.11719 11.8336 2.33132 13.0477 5.36666 13.0477H9.00907C12.0444 13.0477 13.2585 11.8336 13.2585 8.79826V7.58412","stroke":"#292D32","strokeWidth":"0.910602","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

OpenInNew.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = OpenInNew;

OpenInNew.default = OpenInNew;
